<template>
    <div class="tablePage">
        <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="headCellStyle"
            :height="tableHeight"
            @selection-change="handleSelectionChange"
            stripe
        >
            <el-table-column type="selection" width="50" />
            <el-table-column v-if="isSys" prop="scopeName" :label="$t('public.table_scope')" show-overflow-tooltip />
            <el-table-column prop="name" :label="$t('device.gateway_name')" show-overflow-tooltip width="200">
                <template #default="{ row }">
                    <i v-icon:theme="['gatewayTypeConvert', row.type]"></i>
                    <!-- <i :class="gatewayTypeConvert(row.type).icon" style="margin-right: 5px; cursor: pointer" :title="$t(gatewayTypeConvert(row.type).title)"></i> -->
                    <el-popover placement="top-start" width="auto" trigger="hover">
                        <v-popoer :rowData="row" :typeWay="$attrs.sensorWay" />
                        <span slot="reference">
                            <span>{{ row.name }}</span>
                        </span>
                    </el-popover>
                </template>
            </el-table-column>
          <el-table-column prop="mac" label="mac" show-overflow-tooltip />
<!--            <el-table-column prop="sceneName" :label="$t('public.table_arch')" show-overflow-tooltip />-->
            <el-table-column prop="carrierName" width='220' :label="$t('public.table_carrier')" >
                <template #default="{ row }">
                  <CardSwipper :key='Math.random()' :list='row.carrierList'>
                    <template #title={item}>
                      {{ item.sceneName }}
                    </template>
                    <template #default='{item}'>
                      <div class='uk-flex'>
                        <div style='width: 30px' class='bd-r uk-flex uk-flex-center'>
                          <i
                            :class="carrierTypeConvert(item.type).icon"
                            :title="$t(carrierTypeConvert(item.type).title)"
                            style="margin-right: 5px; cursor: pointer"
                            class='uk-margin-remove'
                            @click="handleCarrierFn(item)"
                          ></i>
                        </div>
                        <div class='uk-flex-1'>
                          {{ item.carrierName }}
                        </div>
                      </div>
                    </template>

                  </CardSwipper>
                </template>
            </el-table-column>

            <el-table-column prop="stopTime" :label="$t('integration.down_time_')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ $timetransition(row.stopTime) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="updateTime" :label="$t('public.update_time')" width="120" show-overflow-tooltip>
              <template #default='{row}'>
                {{$timetransition(row.updateTime)}}
              </template>
            </el-table-column>
            <el-table-column prop="optare" fixed='right' :label="$t('public.table_operation')" width="120" align="center">
                <template #default="{ row }">
                    <el-button type="text" size="small" v-for="item in optareBtn" :key="item.id" :title="$t(item.title)" :icon="item.icon" @click="handle(item.method, row)"></el-button>
                    <!-- v-has="item.vHas" -->
                </template>
            </el-table-column>
        </el-table>

      <!-- 监测点详情 -->
      <MonitorDialog :visible.sync='dialogVisible' :carrier-info='carrierDetail'></MonitorDialog>
    </div>
</template>

<script>
import { gatewayTypeConvert, equiStatusConvert, configStatusConvert, carrierTypeConvert } from '@/utils/convert'
import prover from '../components/Proper.vue'
import { getIsSys } from '@/utils/permission'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import { carrierDetail } from '@/api/modules/carrier'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'
export default {
  props: ['loading', 'tableData'],
  components: {
    MonitorDialog,
    CardSwipper,
    'v-popoer': prover
  },
  data () {
    return {
      dialogVisible: false,
      isLoading: false,
      gatewayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      carrierDetail: null,
      optareBtn: [
        {
          id: 1,
          title: $t('integration.modify_customer'),
          icon: 'el-icon-edit-outline',
          vHas: [],
          method: 'editScopeRowFn'
        },
        {
          id: 4,
          title: 'device.reuse',
          icon: 'el-icon-refresh-right',
          vHas: [],
          method: 'useAgainRowFn'
        },
        {
          id: 5,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },
        {
          id: 2,
          title: $t('public.tbopt_delete'),
          icon: 'el-icon-delete',
          vHas: [],
          method: 'delRowFn'
        }
      ],

      isSys: true,
      CarrierTypeArray: []
    }
  },

  mounted () {
    this.isSys = getIsSys()
  },
  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    handleCarrierFn (item) {
      // const array = carrierName.split('-')
      this.dialogVisible = true
      this.isLoading = true

      carrierDetail(item.type, item.id)
        .then(({ result }) => {
          this.dialogVisible = true
          this.isLoading = true
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
